<router-outlet></router-outlet>

<mat-toolbar *ngIf="entityLoaded" class="homeTheme"  [attr.dir]="wksEntity.directionInput !== undefined ? wksEntity.directionInput !== undefined : 'lrt'">

  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>menu</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <span mat-menu-item >
      <span>
        <!--<mat-icon style="margin-right: -1px;">language</mat-icon>-->
        {{ 'COMMUN.MENU.LANGUAGE_DETECTED' | translate }} : <b>{{ browserLang | translate }}</b> 
      </span>
    </span>
    <button mat-menu-item [matMenuTriggerFor]="langs">{{ 'COMMUN.MENU.LANGS' | translate }}</button>
    <button mat-menu-item (click)="toggleDarkTheme($event)">
        <span *ngIf="themeIsDark" >{{ 'COMMUN.THEME.LIGTH'| translate }}</span>
        <span *ngIf="!themeIsDark" > {{ 'COMMUN.THEME.DARK' | translate }}</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="version">{{ 'Version'}}</button>
    <!--
    <span mat-menu-item >
      <span>
          <p> Version </p> 
          <p> FE {{ versionFE }} </p> 
          <p> BE {{ versionBE }} </p> 
      </span>
  </span>
  -->
  </mat-menu>
  <mat-menu #version="matMenu">
    <span mat-menu-item >
      <p> FE {{ versionFE }} </p> 
    </span>
    <span mat-menu-item >
      <p> BE {{ versionBE }} </p> 
    </span>
  </mat-menu>
  <mat-menu #langs="matMenu">
    <button *ngFor="let lang of translate.getLangs()" mat-menu-item (click)="translate.use(lang); settingInputDirection(lang);">
      {{ 'COMMUN.MENU.' + lang | translate }}
    </button>
  </mat-menu>
  <div style="margin-left: 20px;">
    <mat-button-toggle-group style="border-top-width: 0px;border-left-width: 0px;border-bottom-width: 0px;border-right-width: 0px;">
      <button *ngFor="let langCur of usersLanguages" mat-icon-button 
        (click)="translate.use(langCur.langFile); settingInputDirection(langCur.lang); settingLangsButtons(langCur.langFile)"
            [ngStyle]="{'display': langCur.langDisplay}"  >
        <span class="flag-icon flag-icon-{{langCur.langFlag}} flag-icon-squared"></span>
        <!-- [hidden]="langCur.langHidden"-->
      </button>
    </mat-button-toggle-group>
  </div>
  <span class="flexExpand"></span>
  <span *ngIf="corporateName && !wksLogoHomeTitle">
    {{ corporateName }}
  </span>
  <span *ngIf="wksLogoHomeTitle">
    <img [src]="logoTitleToShow | safeHtml: 'resourceUrl' " style="width: 200px; height: 50px;" 
                            [ngStyle]="{'width': wksLogoHomeTitle.width, 'height': wksLogoHomeTitle.height }">
  </span>
  <span class="flexExpand"></span>
  <span (click)="returnHome()" >NautikoWS</span>

</mat-toolbar>

<div *ngIf="entityLoaded" [attr.dir]="wksEntity.directionInput !== undefined ? wksEntity.directionInput !== undefined : 'lrt'">
  
    <app-appointment-form *ngIf="isAppointment && entityLoaded" 
                      [wksEntity]="wksEntity" 
                      [countryFmt]="countryFmt" 
                      [wksLogoHome]="wksLogoHome" [wksEntityParams]="wksEntityParams">
    </app-appointment-form>

    <app-login *ngIf="doAuthenticateUser || doLoginAccount "  
        [optionItem]="optionItem"
        (returnData)="loginAuthenticateAccount($event)"
        (loginEvent)="loginResult($event)">
    </app-login>

    <app-planning *ngIf="displayPlanning && entityLoaded" style="height: 80%;"
            [wksEntity]="wksEntity" 
            [countryFmt]="countryFmt" 
            [wksLogoHome]="wksLogoHome" 
            [wksEntityParams]="wksEntityParams">
    </app-planning>

    <app-wks-home *ngIf="displayWorkHome && entityLoaded"
      [displayWksHome]="displayWksHome" 
      (optionEvent)="loginAccount($event)">
    </app-wks-home>

    <app-wks-appointment-detail *ngIf="displayAppointmentDetail && entityLoaded"
        [displayApptmntDetail]="displayApptmntDetail" 
        (returnData)="returnAppointmentDetail($event)">
    </app-wks-appointment-detail>

    <app-create-account *ngIf="doCreateAccount && entityLoaded"
      (returnData)="returnCreate($event)" >
    </app-create-account>

    <app-update-pwd *ngIf="changePassword"
      [optionItem]="optionItem"
      (returnData)="updatePwdEvent($event)">
    </app-update-pwd>
<!-- displayQuotation -->
    <app-quotation-waiting *ngIf="displayQuotation"
      [statutCall]="'quotes'"
      [encodedReference]= "encodedReference"
      [wksEntity] = "wksEntity">
    </app-quotation-waiting>
<!-- verifyEmail -->
    <app-verifymail-waiting *ngIf="verifyEmail && entityLoaded"
      [statutCall]="'verifyEmail'"
      [encodedReference]= "encodedReference"
      [wksEntity] = "wksEntity">
    </app-verifymail-waiting>

<!-- linkPhotos-->
    <app-work-photos *ngIf="isLinkPhotos && entityLoaded"
      [wksWorks] = "undefined"
      [encodedReference]= "encodedReference"
      [wksEntity] = "wksEntity"
      [callOrigin] = "callOrigin"
      >
    </app-work-photos>
<!-- Inventory interface -->
 
    <app-inventory-card *ngIf="displayInventory && entityLoaded" style="height: 80%;"
      [wksEntity]="wksEntity" 
      [countryFmt]="countryFmt" 
      [wksLogoHome]="wksLogoHome" 
      [wksEntityParams]="wksEntityParams"
    >
    </app-inventory-card >
<!-- suppliers orders -->
    <app-suppliers-orders *ngIf="displaySuppliersOrders && entityLoaded" style="height: 80%;"
      [wksEntity]="wksEntity" 
      [countryFmt]="countryFmt" 
      [wksLogoHome]="wksLogoHome" 
      [wksEntityParams]="wksEntityParams">

    </app-suppliers-orders>
<!-- movements stocks interface -->
    <app-movements-card *ngIf="displayMovements && entityLoaded" style="height: 80%;"
      [wksEntity]="wksEntity" 
      [countryFmt]="countryFmt" 
      [wksLogoHome]="wksLogoHome" 
      [wksEntityParams]="wksEntityParams"
      [applicationStock]="applicationStock"
    >
    </app-movements-card>
  </div>

 <!-- app-scanner-qrcode-v1   -->
    <!--
    <app-scanner-qrcode-v1 *ngIf="testScannerQrCodeV1">
    </app-scanner-qrcode-v1>

    <app-ngx-scanner-v2 *ngIf="testScannerQrCodeV2"
      [callMethod]="'TEST'">
    </app-ngx-scanner-v2>

    <app-scanner-hytera *ngIf="testScannerHytera">
    </app-scanner-hytera>
    <app-scanner-hytera-rs232 *ngIf="testScannerHyteraRs232">
    </app-scanner-hytera-rs232>

    <app-scanner-ct37 *ngIf="testScannerCT37">
    </app-scanner-ct37>
-->
    <app-scanner-ct37-basic [versionFE]="versionFE" *ngIf="testScannerCT37Basic">
    </app-scanner-ct37-basic>
<!--
    <app-webcam-snapshot-v1 style="width: 100%" *ngIf="testSnapshotV1">
    </app-webcam-snapshot-v1>
    
    <app-webcam-snapshot-v2 *ngIf="testSnapshotV2">
    </app-webcam-snapshot-v2>
    <app-work-photos *ngIf="testWorkPhotos"
      [wksWorks] = "undefined">
    </app-work-photos>
-->

